export default __webpack_public_path__ + "static/media/checked-in.5e11f01d.svg";